import './App.css';
import React from 'react';
import InfoCollection from "./InfoCollection";
import PaymentArea from "./PaymentArea";
import Shop from "./Shop";

export const PAYMENT_LABEL_MAPPING = {
    'aaf': {
        label: 'AAF - AAF Form has been completed on Tangent India Directory',
        type: 'admin',
        perMember: 1000,
        purposeLabel: 'Confirmation Number of AAF Form from Tangent India Directory'
    },
    'charter-fees': {
        label: 'Charter Fees',
        type: 'admin',
        amount: 1000,
        purposeLabel: 'City of New Club'
    },
    'new-member': {
        label: 'New Member Payment',
        type: 'admin',
        perMember: 2000,
        purposeLabel: 'Name(s) of New Member(s)'
    },
    'transfer-fees': {
        label: 'Transfer Fees',
        type: 'admin',
        amount: 500,
        purposeLabel: 'Name and new Club of the Member'
    },
    'project': {
        label: 'Project',
        type: 'cont',
        purposeLabel: 'Name of Project'
    },
    // 'project-event': {
    //     label: 'Project Related Event',
    //     type: 'cont',
    //     purposeLabel: 'Name of Event and Project'
    // },
    'admin-event': {
        label: 'Administrative Event',
        type: 'admin',
        purposeLabel: 'Name of Event'
    },
    'tbni': {
        label: 'Tangent BNI Membership (1 Year)',
        type: 'admin',
        purposeLabel: 'How did you find out about TBNI?',
        amount: 1000
    },
    // 'mtm': {
    //     label: 'Mid Term Meet',
    //     type: 'admin',
    //     amount: 9999,
    //     purposeLabel: 'Name of Attendee'
    // },
    'regalia': {
        label: 'Regalia',
        type: 'admin',
        desc: 'Name Bars - ₹150<br/>' +
            'Tangent Pin - ₹150<br/>' +
            'Past Chairperson Pin - ₹400<br/>' +
            // 'Club Secretary Pin - ₹300<br/>' +
            'Others - Contact the Treasurer for Amount',
        // purposeLabel: 'List of items and quantities',
        purposeLabel: 'Please enter your shipping address',
        products: {
            'name-bar': {
                label: 'Name Bars',
                price: 150
            },
            'tangent-pin': {
                label: 'Tangent Pin',
                price: 150
            },
            'past-chairperson-pin': {
                label: 'Past Chairperson Pin',
                price: 400
            },
            //
            'others': {
                label: 'Others'
            }
        },
    }
}

export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.changeState = this.changeState.bind(this);
        this.setCart = this.setCart.bind(this);
    }

    changeState(key, value) {
        this.setState({
            ...this.state,
            [key]: value
        })
    }

    setCart(store, total) {
        let storeString = 'Shipping Address: ' + this.state.paymentInfo.purpose + '\n'
        Object.keys(PAYMENT_LABEL_MAPPING['regalia']['products']).filter(product => PAYMENT_LABEL_MAPPING['regalia']['products'][product].price).forEach(product => {
            storeString += (PAYMENT_LABEL_MAPPING['regalia']['products'][product]['label'] + ' - ' + store[product] + '\n')
        })
        storeString += ('Other Products: ' + store.otherNames + ' - ' + store.otherAmount)
        this.setState({
            ...this.state,
            paymentInfo: {
                ...this.state.paymentInfo,
                // purpose: this.state.paymentInfo.purpose + ' - ' + JSON.stringify(store),
                // purpose: storeString,
                notes: storeString,
                amount: total
            },
            shopUpdated: true
        })
    }

    render() {
        if (this.state['paymentInfo']) {
            if (this.state.paymentInfo.paymentType === 'regalia' && !this.state.shopUpdated) {
                return (
                    <Shop info={PAYMENT_LABEL_MAPPING['regalia']} callback={this.setCart}/>
                )
            }
            return (
                <PaymentArea amount={this.state.paymentInfo.amount} email={this.state.paymentInfo.email} phone={this.state.paymentInfo.phone} name={this.state.paymentInfo.name}
                    paymentInfo={this.state.paymentInfo}
                             paymentType={PAYMENT_LABEL_MAPPING[this.state.paymentInfo.paymentType]['type']}
                />
            )
        }
        return (
            <InfoCollection onClick={(info) => this.changeState('paymentInfo', info)} paymentGatewayMap={PAYMENT_LABEL_MAPPING}/>
        );
    }
}